app.service('searchShopView', function(
	searchShopInput,
	searchShopManager,
	searchShopMap
) {
	function init() {
		searchShopManager.init();
		searchShopMap.init();
		searchShopInput.init();
	}

	return { init };
});